import { MutationTree } from 'vuex';
import { FiltersState } from './typings';
import { Filter } from '@/services/filters';
import { SET_FILTER, RESET_FILTERS } from '@/store/mutation-types';

const mutations: MutationTree<FiltersState> = {
  [SET_FILTER](state, f: Filter): void {
    state.byId[f.id] = f;
  },
  [RESET_FILTERS](state): void {
    state.byId = {};
  },
};

export default mutations;
